/**
 * @description: 客户资料报表
 * @author: lyr
*/
<template>
    <div class="customer-data-report">
        <div class="list">
            <el-form :inline="true" :model="list_form">
                <el-form-item label="添加时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable  placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户姓名" v-show="report_type==1||report_type==2">
                    <el-input placeholder="请输入客户姓名" clearable v-model="list_form.user_name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" v-show="report_type==1||report_type==2">
                    <el-input placeholder="请输入手机号" clearable v-model="list_form.mobile"></el-input>
                </el-form-item>
                <el-form-item label="营销员工" v-show="report_type==2||report_type==3">
                    <el-input placeholder="请输入营销员工" clearable v-model="list_form.marketing_staff_name"></el-input>
                </el-form-item>
                <el-form-item class="pull-right">
                    <el-button :type="report_type==1?'primary':''" @click="changeReportType(1)">按客户</el-button>
                    <el-button :type="report_type==2?'primary':''" @click="changeReportType(2)">按营销员工-客户</el-button>
                    <el-button :type="report_type==3?'primary':''" @click="changeReportType(3)">按营销员工</el-button>
                    <el-button :type="report_type==4?'primary':''" @click="changeReportType(4)">按门店</el-button>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-if="report_type==1||report_type==2"
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table"
                :key="tableKey"
                @sort-change="listOrder">
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="create_time" label="添加时间" width="150"></el-table-column>
                <el-table-column prop="user_name" label="客户姓名"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="marketing_staff_name" label="营销员工"></el-table-column>
                <el-table-column prop="last_consumption_time" label="最近消费时间" width="150" sortable="custom"></el-table-column>
                <el-table-column prop="consumption_num" label="消费次数" width="100" sortable="custom"></el-table-column>
                <el-table-column prop="consumption_amount" label="消费金额" width="100" sortable="custom"></el-table-column>
                <el-table-column prop="sex_name" label="性别"></el-table-column>
                <el-table-column prop="birthday" label="生日" width="110"></el-table-column>
                <el-table-column prop="age" label="年龄"></el-table-column>
                <el-table-column prop="business" label="行业" width="100">
                    <template slot-scope="scope">
                        <el-popover
                            placement="right"
                            title="描述详情"
                            trigger="hover"
                            width="500">
                            <p>{{scope.row.business}}</p>
                            <p slot="reference" class="text-blue">{{scope.row.business.length > 9 ? `${scope.row.business.slice(0, 9)}...` : scope.row.business}}</p>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="desc" label="客户情况" width="100">
                    <template slot-scope="scope">
                        <el-popover
                            placement="right"
                            title="描述详情"
                            trigger="hover"
                            width="500">
                            <p>{{scope.row.desc}}</p>
                            <p slot="reference" class="text-blue">{{scope.row.desc.length > 9 ? `${scope.row.desc.slice(0, 9)}...` : scope.row.desc}}</p>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="consumption_habit" label="消费习惯" width="100">
                    <template slot-scope="scope">
                        <el-popover
                            placement="right"
                            title="描述详情"
                            trigger="hover"
                            width="500">
                            <p>{{scope.row.consumption_habit}}</p>
                            <p slot="reference" class="text-blue">{{scope.row.consumption_habit.length > 9 ? `${scope.row.consumption_habit.slice(0, 9)}...` : scope.row.consumption_habit}}</p>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" width="100">
                    <template slot-scope="scope">
                        <el-popover
                            placement="right"
                            title="描述详情"
                            trigger="hover"
                            width="500">
                            <p>{{scope.row.remark}}</p>
                            <p slot="reference" class="text-blue">{{scope.row.remark.length > 9 ? `${scope.row.remark.slice(0, 9)}...` : scope.row.remark}}</p>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
            <el-table
                v-if="report_type==3"
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table"
                :key="tableKey"
                @sort-change="listOrder">
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="marketing_staff_name" label="营销员工"></el-table-column>
                <el-table-column prop="customer_count" label="客户数" sortable="custom">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="onCustomerCountClick(scope.row)">{{scope.row.customer_count}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="incomplete_customer_count" label="不完整资料客户数" sortable="custom"></el-table-column>
            </el-table>
            <el-table
                v-if="report_type==4"
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table"
                :key="tableKey"
                @sort-change="listOrder">
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="customer_count" label="客户数" sortable="custom"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'customer-data-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                report_type: '1', // 1按客户 2按营销员工-客户 3按营销员工 4按门店
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    mobile: '',
                    user_name: '',
                    marketing_staff_name: '',
                    order_by: '', /*last_consumption_time_asc：最近消费时间正序
                                    last_consumption_time_desc：最近消费时间倒序
                                    consumption_num_asc：消费次数正序
                                    consumption_num_desc：消费次数倒序
                                    consumption_amount_asc：消费金额正序
                                    consumption_amount_desc：消费金额倒序
                                    customer_count_asc：客户数正序
                                    customer_count_desc：客户数倒序
                                    incomplete_customer_count_asc：不完整客户数正序
                                    incomplete_customer_count_desc：不完整客户数倒序*/
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                tableKey: Math.random(),
            }
        },
        computed: {
           
        },
        mounted: function() {
            // 日期
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[1].id;
                this.getList(1);
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
                _this.list_page = page;
                let url = this.report_type == 1 ? '/getList' : this.report_type == 2 ? '/getListByAdmin' : this.report_type == 3 ? '/getSumByAdmin' : '/getSumByShop'
				Vue.axios.post('CustomerManage'+ url, {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.list_form.shop_id,
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
                            "mobile": _this.list_form.mobile,
                            "user_name": _this.list_form.user_name,
                            "marketing_staff_name": _this.list_form.marketing_staff_name,
                            "order_by": _this.list_form.order_by,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.count)
						}
						_this.list_table = res.data.response.result.data;
                        _this.tableKey = Math.random();
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            // 表格排序
            listOrder(col) {
                console.log(col)
                if (col.prop == 'last_consumption_time') {
                    if (col.order == 'ascending') {
                        this.list_form.order_by = 'last_consumption_time_asc'
                    }else if (col.order == 'descending') {
                        this.list_form.order_by = 'last_consumption_time_desc'
                    }else {
                        this.list_form.order_by = ''
                    }
                }else if (col.prop == 'consumption_num') {
                    if (col.order == 'ascending') {
                        this.list_form.order_by = 'consumption_num_asc'
                    }else if (col.order == 'descending') {
                        this.list_form.order_by = 'consumption_num_desc'
                    }else {
                        this.list_form.order_by = ''
                    }
                }else if (col.prop == 'consumption_amount') {
                    if (col.order == 'ascending') {
                        this.list_form.order_by = 'consumption_amount_asc'
                    }else if (col.order == 'descending') {
                        this.list_form.order_by = 'consumption_amount_desc'
                    }else {
                        this.list_form.order_by = ''
                    }
                }else if (col.prop == 'customer_count') {
                    if (col.order == 'ascending') {
                        this.list_form.order_by = 'customer_count_asc'
                    }else if (col.order == 'descending') {
                        this.list_form.order_by = 'customer_count_desc'
                    }else {
                        this.list_form.order_by = ''
                    }
                } else if (col.prop == 'incomplete_customer_count') {
                    if (col.order == 'ascending') {
                        this.list_form.order_by = 'incomplete_customer_count_asc'
                    }else if (col.order == 'descending') {
                        this.list_form.order_by = 'incomplete_customer_count_desc'
                    }else {
                        this.list_form.order_by = ''
                    }
                }
                this.getList(1)
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },

            // 切换表格
            changeReportType(type) {
                this.report_type = type
                this.list_form.order_by = ''
                this.list_form.marketing_staff_name = ''
                this.list_page = 1
                this.list_total = 0
                this.list_table = []
                this.listQuery() 
            },

            onCustomerCountClick(row) {
                this.report_type = 2 // 按营销员工-客户
                this.list_form.order_by = ''
                this.list_form.marketing_staff_name = row.marketing_staff_name
                this.list_page = 1
                this.list_total = 0
                this.list_table = []
                this.listQuery() 
            },
            
            listExport: function() {
                let url = this.report_type == 1 ? 'export' : this.report_type == 2 ? 'exportByAdmin' : this.report_type == 3 ? 'exportSumByAdmin' : 'exportSumByShop'
                window.location.href = Vue.ctUrl + "CustomerManage/" + url +
                    "?start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&mobile=" + this.list_form.mobile +
                    "&user_name=" + this.list_form.user_name +
                    "&marketing_staff_name=" + this.list_form.marketing_staff_name +
                    "&order_by=" + this.list_form.order_by;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>

</style>